'use client';

import { VersionedContent } from '@/shared/versionedContent';
import React, { useState } from 'react';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import MarkupRenderer from '../privacy/MarkupRenderer';
import Header from '../components/Header';
import Footer from '../components/Footer';

interface PolicyProps {
  policyVersions: VersionedContent[];
}

const Policys: React.FC<PolicyProps> = ({ policyVersions }: PolicyProps) => {
  const [selectedVersion, setSelectedVersion] = useState<VersionedContent>(
    policyVersions[0] // Default to latest version
  );

  const {
    i18nHelper: { t },
    language
  } = useGlobalClientContext();

  // Update the selected version when language changes
  React.useEffect(() => {
    if (policyVersions.length > 0) {
      setSelectedVersion(policyVersions[0]);
    }
  }, [language, policyVersions]);

  return (
    <div className="flex flex-col max-w-[1280px] mx-auto">
      <Header />
      <div className="flex flex-col mt-[132px] w-full gap-y-9xl mb-[260px]">
        <div className="h-[158px] space-y-7xl border border-l-0 border-r-0 border-t-0 border-b border-gray-100">
          <div className="flex flex-col gap-y-2xs">
            <h1 className="font-semibold !text-4xl leading-none !lineHeight-[10000px]">
              {t('policy.notice.title', {})}
            </h1>
            <p className="text-gray-600 mb-16 font-semibold font-medium">
              {t('privacy.notice.last_updated', {
                date: selectedVersion.lastUpdated
              })}
            </p>
          </div>
        </div>

        {/* Main Content */}
        {selectedVersion.markdownContent && (
          <div className="w-full">
            {selectedVersion?.markdownContent?.[language] && (
              <MarkupRenderer
                content={selectedVersion.markdownContent[language]}
                convertEmailToLink={true}
              />
            )}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Policys;
